import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import classes from "./index.module.css";
import { buildRoutePoints } from "./_replay/routeUtils";
import { useRoutePlayback } from "./_replay/useRoutePlayback";
import RouteReplayControls from "./_replay/RouteReplayControls";
import { BsArrowLeftShort } from "react-icons/bs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  getChipColor,
} from "../../../utilities/commonFunctions";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  LOCATION,
  MAP_ROUTE_LIST,
  VIEW_HISTORY,
} from "../../../api-calls/api-urls";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Paper,
  Collapse,
  Typography,
  Chip,
  Button,
} from "@mui/material";
import moment from "moment";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import FilterContainer from "./filterContainer";

const ExpandMore = styled((props) => {
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function Map() {
  const navigate = useNavigate();
  const location = useLocation();
  const date = location?.state?.date || null;
  const userName = location?.state?.userName || null;
  const teamName = location?.state?.teamName || null;
  const userPhoto = location?.state?.userPhoto || null;
  const [markerList, setMarkerList] = useState([]);
  const [stopPoints, setStopPoints] = useState([]);
  const [idlePoints, setIdlePoints] = useState([]);
  const [activePointer, setActivePointer] = useState(null);
  const [fromDate, setFromDate] = useState();
  const [travelHistory, setTravelHistory] = useState([]);
  const [rawIdlePoints, setRawIdlePoints] = useState([]);
  const [totalDistance, setTotalDistance] = useState(0);
  const [attendanceData, setAttendanceData] = useState([]);
  const [polylinePath, setPolylinePath] = useState([]);
  const [mapcenter, setMapcenter] = useState({});
  const [activeMarker, setActiveMarker] = useState(null);
  const [activeLocation, setActiveLocation] = useState();
  const [expanded, setExpanded] = React.useState(false);
  const { id } = useParams();

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const getViewRouteData = async (date) => {
    try {
      const { data } = await authApi.get(
        `${MAP_ROUTE_LIST}/${id}?date=${moment(date).format("YYYY-MM-DD")}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log("MarkerList", data.locations);
      setMarkerList(data.locations);
      const data1 = await authApi.get(
        `${VIEW_HISTORY}/${data.user_id}?date=${moment(date).format(
          "YYYY-MM-DD"
        )}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log("Travel history data:", data1?.data);
      const historyData = data1?.data?.data || [];
      setTravelHistory(historyData);
      // Set map center from first point in travel history, with fallback
      if (historyData?.length > 0 && historyData[0]?.length > 0 && historyData[0][0]?.location_info) {
        setMapcenter({
          lat: parseFloat(historyData[0][0].location_info.lat),
          lng: parseFloat(historyData[0][0].location_info.lng),
        });
      }
      setStopPoints(data1?.data?.stopPoints || []);
      const idlePointsFromApi = data1?.data?.idlePoints || [];
      setRawIdlePoints(idlePointsFromApi);
      setIdlePoints(idlePointsFromApi.map((ip) => ({
        item: { location_info: { lat: ip.latlng[0], lng: ip.latlng[1] } },
        time: ip.startTime,
        endTime: ip.endTime,
        duration: ip.duration,
        isIdle: true,
      })));
      setAttendanceData(data1?.data?.attendance || []);
      const totalDis = (data1?.data?.distance || 0) / 1000;
      setTotalDistance(totalDis.toFixed(2));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // console.log(date, location);
    if (date) {
      // console.log(date);
      // const date = day
      dateObject(moment(date, "MM-DD-YYYY").toDate());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  useEffect(() => {
    getRouteDirections();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [travelHistory]);

  const getRouteDirections = async () => {
    // ... existing code ...
    console.log("travelHistory", travelHistory);
    if (travelHistory?.length > 0) {
      const array = [];
      travelHistory.forEach((item) => {
        if (item && item?.length > 0) {
          const locations = item
            .filter(
              (location) =>
                typeof location === "object" &&
                !isNaN(parseFloat(location?.location_info?.lat)) &&
                !isNaN(parseFloat(location?.location_info?.lng))
            )
            .map((location) => ({
              lat: parseFloat(location?.location_info?.lat),
              lng: parseFloat(location?.location_info?.lng),
            }));

          array.push(locations);
        }
      });
      console.log("Polline Path ===> ", array, travelHistory);
      setPolylinePath(array);
      // setPolylinePath(
      //   travelHistory.map((item) => ({
      //     lat: parseFloat(item.location_info.lat),
      //     lng: parseFloat(item.location_info.lng),
      //   }))
      // );
    }
    // let waypoints = []
    // // Calculate the waypoints for all the locations except the start and end locations
    // if (travelHistory > 0) {
    //   const maxWaypointsPerSegment = 15;
    //   for (let i = 0; i < travelHistory; i += maxWaypointsPerSegment) {
    //     waypoints.push({
    //       location: {
    //         lat: parseFloat(travelHistory[i].location_info.lat),
    //         lng: parseFloat(travelHistory[i].location_info.lng),
    //       }
    //     })
    //   }
    //   console.log("Location Waypoitisfshg", waypoints);

    //   try {
    //     const response = await new Promise((resolve, reject) => {
    //       const directionsService = new window.google.maps.DirectionsService();
    //       directionsService.route(
    //         {
    //           origin: {
    //             lat: parseFloat(travelHistory[0].location_info.lat),
    //             lng: parseFloat(travelHistory[0].location_info.lng), // Corrected
    //           },
    //           destination: {
    //             lat: parseFloat(travelHistory[travelHistory - 1].location_info.lat),
    //             lng: parseFloat(travelHistory[travelHistory - 1].location_info.lng), // Corrected
    //           },
    //           waypoints: waypoints,
    //           travelMode: "DRIVING",
    //         },
    //         (result, status) => {
    //           if (status === window.google.maps.DirectionsStatus.OK) {
    //             resolve(result);
    //           } else {
    //             reject(status);
    //           }
    //         }
    //       );
    //     });
    //     console.log(response);

    //     let dis = 0;

    //     if (response && response.routes > 0) {
    //       response.routes[0].legs.map((item) => {
    //         dis += parseFloat(item.distance.text)
    //       });

    //       console.log(dis.toFixed(2));
    //       // setTotalDistance(dis.toFixed(2));
    //     }
    //     setDirections(response);
    //   } catch (error) {
    //     console.log("Error fetching directions:", error);
    //   }
    // } else {
    //   setDirections(null);
    // }
  };

  // ---- Route replay (player movement playback) ----
  const routePoints = useMemo(
    () => buildRoutePoints(travelHistory),
    [travelHistory]
  );

  const playback = useRoutePlayback({ routePoints, idlePoints: rawIdlePoints });

  const isReplaying = playback.isPlaying || playback.progress > 0;

  const { replayTraveled, replayRemaining } = useMemo(() => {
    if (!isReplaying || !playback.currentPosition || routePoints.length < 2) {
      return { replayTraveled: [], replayRemaining: [] };
    }
    const idx = playback.currentIndex;
    const traveled = routePoints
      .slice(0, idx + 1)
      .map((p) => ({ lat: p.lat, lng: p.lng }));
    traveled.push(playback.currentPosition);
    const remaining = [playback.currentPosition];
    for (let i = idx + 1; i < routePoints.length; i++) {
      remaining.push({ lat: routePoints[i].lat, lng: routePoints[i].lng });
    }
    return { replayTraveled: traveled, replayRemaining: remaining };
  }, [isReplaying, playback.currentIndex, playback.currentPosition, routePoints]);

  const activeHaltDuration =
    playback.activeHaltIndex != null
      ? rawIdlePoints[playback.activeHaltIndex]?.duration ?? null
      : null;

  const wasPlayingBeforeScrubRef = useRef(false);
  const { isPlaying: playbackIsPlaying, play: playbackPlay, pause: playbackPause } = playback;
  const handleScrubStart = useCallback(() => {
    wasPlayingBeforeScrubRef.current = playbackIsPlaying;
    playbackPause();
  }, [playbackIsPlaying, playbackPause]);
  const handleScrubEnd = useCallback(() => {
    if (wasPlayingBeforeScrubRef.current) playbackPlay();
  }, [playbackPlay]);

  const getReplayMarkerSVG = () => `<svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="15" fill="#3B82F6" fill-opacity="0.25"/>
      <circle cx="17" cy="17" r="8" fill="#2563EB" stroke="white" stroke-width="3"/>
    </svg>`;

  const getMarkerSVG = (item) => {
    if (item.status === "pending") {
      const isSelectedMarker = activeMarker && activeMarker === item.title;

      if (isSelectedMarker) {
        return `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.25" y="0.25" width="47.5" height="47.5" rx="3.75" fill="#D09D1C" stroke="#D09D1C" stroke-width="0.5"/>
      <path d="M8.66626 15.3345L8.66686 15.3339C9.22604 14.7738 9.88349 14.5007 10.6663 14.5007H17.333H17.833V14.0007V10.6673C17.833 9.88444 18.1062 9.22627 18.6666 8.66587C19.2257 8.10676 19.8832 7.83398 20.6663 7.83398H27.333C28.1159 7.83398 28.774 8.10663 29.3343 8.66569C29.8936 9.226 30.1663 9.88422 30.1663 10.6673V14.0007V14.5007H30.6663H37.333C38.1159 14.5007 38.774 14.7738 39.3345 15.3342C39.8936 15.8933 40.1663 16.5509 40.1663 17.334V35.6673C40.1663 36.4503 39.8936 37.1085 39.3345 37.6688C38.7742 38.228 38.116 38.5007 37.333 38.5007H10.6663C9.88321 38.5007 9.22567 38.2279 8.66656 37.6688C8.10616 37.1084 7.83301 36.4502 7.83301 35.6673V17.334C7.83301 16.5511 8.10613 15.8937 8.66626 15.3345ZM20.1663 14.0007V14.5007H20.6663H27.333H27.833V14.0007V10.6673V10.1673H27.333H20.6663H20.1663V10.6673V14.0007Z" fill="white" stroke="white"/>
      </svg>
      `;
      } else {
        return `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.25" y="0.25" width="47.5" height="47.5" rx="3.75" fill="#F0EEE8" stroke="#D09D1C" stroke-width="0.5"/>
        <path d="M8.66626 15.3345L8.66686 15.3339C9.22604 14.7738 9.88349 14.5007 10.6663 14.5007H17.333H17.833V14.0007V10.6673C17.833 9.88444 18.1062 9.22627 18.6666 8.66587C19.2257 8.10676 19.8832 7.83398 20.6663 7.83398H27.333C28.1159 7.83398 28.774 8.10663 29.3343 8.66569C29.8936 9.226 30.1663 9.88422 30.1663 10.6673V14.0007V14.5007H30.6663H37.333C38.1159 14.5007 38.774 14.7738 39.3345 15.3342C39.8936 15.8933 40.1663 16.5509 40.1663 17.334V35.6673C40.1663 36.4503 39.8936 37.1085 39.3345 37.6688C38.7742 38.228 38.116 38.5007 37.333 38.5007H10.6663C9.88321 38.5007 9.22567 38.2279 8.66656 37.6688C8.10616 37.1084 7.83301 36.4502 7.83301 35.6673V17.334C7.83301 16.5511 8.10613 15.8937 8.66626 15.3345ZM20.1663 14.0007V14.5007H20.6663H27.333H27.833V14.0007V10.6673V10.1673H27.333H20.6663H20.1663V10.6673V14.0007Z" fill="#D09D1C" stroke="#D09D1C"/>
        </svg>
        `;
      }
    } else if (item.status === "completed") {
      // console.log(item);
      const isSelectedMarker = activeMarker && activeMarker === item.title;

      if (isSelectedMarker) {
        return `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.25" y="0.25" width="47.5" height="47.5" rx="3.75" fill="#1A6B44" stroke="#1A6B44" stroke-width="0.5"/>
      <path d="M8.66626 15.3345L8.66686 15.3339C9.22604 14.7738 9.88349 14.5007 10.6663 14.5007H17.333H17.833V14.0007V10.6673C17.833 9.88444 18.1062 9.22627 18.6666 8.66587C19.2257 8.10676 19.8832 7.83398 20.6663 7.83398H27.333C28.1159 7.83398 28.774 8.10663 29.3343 8.66569C29.8936 9.226 30.1663 9.88422 30.1663 10.6673V14.0007V14.5007H30.6663H37.333C38.1159 14.5007 38.774 14.7738 39.3345 15.3342C39.8936 15.8933 40.1663 16.5509 40.1663 17.334V35.6673C40.1663 36.4503 39.8936 37.1085 39.3345 37.6688C38.7742 38.228 38.116 38.5007 37.333 38.5007H10.6663C9.88321 38.5007 9.22567 38.2279 8.66656 37.6688C8.10616 37.1084 7.83301 36.4502 7.83301 35.6673V17.334C7.83301 16.5511 8.10613 15.8937 8.66626 15.3345ZM20.1663 14.0007V14.5007H20.6663H27.333H27.833V14.0007V10.6673V10.1673H27.333H20.6663H20.1663V10.6673V14.0007Z" fill="white" stroke="white"/>
      </svg>
      `;
      } else {
        return `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.25" y="0.25" width="47.5" height="47.5" rx="3.75" fill="#F1F6F3" stroke="#1A6B44" stroke-width="0.5"/>
      <path d="M8.66626 15.3345L8.66686 15.3339C9.22604 14.7738 9.88349 14.5007 10.6663 14.5007H17.333H17.833V14.0007V10.6673C17.833 9.88444 18.1062 9.22627 18.6666 8.66587C19.2257 8.10676 19.8832 7.83398 20.6663 7.83398H27.333C28.1159 7.83398 28.774 8.10663 29.3343 8.66569C29.8936 9.226 30.1663 9.88422 30.1663 10.6673V14.0007V14.5007H30.6663H37.333C38.1159 14.5007 38.774 14.7738 39.3345 15.3342C39.8936 15.8933 40.1663 16.5509 40.1663 17.334V35.6673C40.1663 36.4503 39.8936 37.1085 39.3345 37.6688C38.7742 38.228 38.116 38.5007 37.333 38.5007H10.6663C9.88321 38.5007 9.22567 38.2279 8.66656 37.6688C8.10616 37.1084 7.83301 36.4502 7.83301 35.6673V17.334C7.83301 16.5511 8.10613 15.8937 8.66626 15.3345ZM20.1663 14.0007V14.5007H20.6663H27.333H27.833V14.0007V10.6673V10.1673H27.333H20.6663H20.1663V10.6673V14.0007Z" fill="#1A6B44" stroke="#1A6B44"/>
      </svg>`;
      }
    }
  };

  const dateObject = (date) => {
    console.log(date);
    getViewRouteData(date);
    setFromDate(date);
    getRouteDirections();
  };

  const handleNotReached = async (event, item) => {
    try {
      event.stopPropagation(); // Prevent card click event from firing
      const { data } = await authApi.put(
        `${LOCATION}/mark-not-reached/${item.location._id}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      getViewRouteData(fromDate);
    } catch (error) {
      console.log(error);
    }
  };

  const handleActiveMarker = (marker) => {
    console.log(marker);
    if (marker.location.title === activeMarker) {
      return;
    }
    setActiveLocation(marker);
    setActiveMarker(marker.location.title);
  };

  const handleViewRoute = (event, item) => {
    console.log("trigger view Route", item);
    navigate(`/maps/location-view-route/${item?.location?.slug.toLowerCase()}`);
  };

  const getOtherIcons = (name) => {
    if (name === "start") {
      return `<svg width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 0C8.059 0 0 8.059 0 18C0 31.5 18 44 18 44C18 44 36 31.5 36 18C36 8.059 27.941 0 18 0Z" fill="#22A06B"/>
        <circle cx="18" cy="18" r="10" fill="white"/>
        <text x="18" y="23" font-family="Arial" font-size="12" font-weight="bold" fill="#22A06B" text-anchor="middle">S</text>
      </svg>`;
    } else if (name === "end") {
      return `<svg width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 0C8.059 0 0 8.059 0 18C0 31.5 18 44 18 44C18 44 36 31.5 36 18C36 8.059 27.941 0 18 0Z" fill="#D40000"/>
        <circle cx="18" cy="18" r="10" fill="white"/>
        <text x="18" y="23" font-family="Arial" font-size="12" font-weight="bold" fill="#D40000" text-anchor="middle">E</text>
      </svg>`;
    }
  };

  const getIdleMarkerSVG = (durationSec) => {
    const durationMin = Math.round(durationSec / 60);
    const label = durationMin >= 60
      ? `${Math.floor(durationMin / 60)}h ${durationMin % 60}m`
      : `${durationMin}m`;
    const text = `Idle ${label}`;
    const width = Math.max(60, text.length * 7 + 16);
    const height = 26;
    const mid = width / 2;
    return `<svg width="${width}" height="${height + 7}" viewBox="0 0 ${width} ${height + 7}" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="0" width="${width}" height="${height}" rx="13" fill="#F59E0B"/>
      <text x="${mid}" y="17" font-family="Arial,sans-serif" font-size="11" font-weight="700" fill="white" text-anchor="middle">${text}</text>
      <polygon points="${mid - 5},${height} ${mid + 5},${height} ${mid},${height + 7}" fill="#F59E0B"/>
    </svg>`;
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const handleMouseOver = (index) => {
    // tooltip index tracking (no-op after cleanup)
  };

  const getTimeDifference = (number) => {
    const hours = Math.floor(number / 3600);
    const minutes = Math.floor((number % 3600) / 60);
    const seconds = Math.floor(number % 60);

    return `${hours && hours > 0 ? hours + "hrs " : ""} ${
      minutes && minutes > 0
        ? (minutes < 10 ? "0" + minutes : minutes) + "mins "
        : ""
    } ${seconds < 10 ? "0" + seconds : seconds}sec`;
  };

  const getSummaryDuration = () => {
    if (!attendanceData || attendanceData.length === 0) return null;
    const checkIn = attendanceData[0]?.checkIn;
    // Use the latest checkOut across all attendance records
    const checkOut = attendanceData.reduce((latest, a) => {
      if (!a.checkOut) return latest;
      return !latest || new Date(a.checkOut) > new Date(latest) ? a.checkOut : latest;
    }, null);
    if (!checkIn) return null;
    const start = moment(checkIn);
    const end = checkOut ? moment(checkOut) : moment();
    const totalMins = end.diff(start, "minutes");
    const hours = Math.floor(totalMins / 60);
    const mins = totalMins % 60;
    const timeLabel = checkOut ? "" : " (ongoing)";
    if (hours > 0 && mins > 0) return `${hours}h ${mins}m${timeLabel}`;
    if (hours > 0) return `${hours}h${timeLabel}`;
    return `${mins}m${timeLabel}`;
  };

  const generateRouteReport = () => {
    // Build events from stopPoints (Halt) and markerList completed (Location Visited)
    const events = [];

    stopPoints.forEach((sp) => {
      if (sp.time) {
        events.push({
          startTime: sp.time,
          endTime: sp.endTime || sp.time,
          status: "Halt",
          location: sp.item?.location_info
            ? `${parseFloat(sp.item.location_info.lat).toFixed(5)}, ${parseFloat(sp.item.location_info.lng).toFixed(5)}`
            : "N/A",
        });
      }
    });

    markerList.forEach((ml) => {
      if (ml.status === "completed" && ml.reached_date) {
        events.push({
          startTime: ml.reached_date,
          endTime: ml.reached_date,
          status: "Task Visited",
          location: ml.location?.title || "N/A",
        });
      }
    });

    // Sort all events chronologically
    events.sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

    // For Task Visited rows, set endTime to next event's start (or +1 hour if last)
    for (let i = 0; i < events.length; i++) {
      if (events[i].status === "Task Visited") {
        if (i + 1 < events.length) {
          events[i].endTime = events[i + 1].startTime;
        } else {
          events[i].endTime = new Date(new Date(events[i].startTime).getTime() + 3600000).toISOString();
        }
      }
    }

    // Insert Travelling segments for gaps > 5 minutes between events
    const fullEvents = [];
    for (let i = 0; i < events.length; i++) {
      fullEvents.push(events[i]);
      if (i + 1 < events.length) {
        const gapMs = new Date(events[i + 1].startTime) - new Date(events[i].endTime);
        if (gapMs > 5 * 60 * 1000) {
          fullEvents.push({
            startTime: events[i].endTime,
            endTime: events[i + 1].startTime,
            status: "Travelling",
            location: "NA",
          });
        }
      }
    }

    // Calculate total travelling time
    let travellingMins = 0;
    fullEvents.forEach((e) => {
      if (e.status === "Travelling") {
        travellingMins += (new Date(e.endTime) - new Date(e.startTime)) / 60000;
      }
    });
    const travelHrs = Math.floor(travellingMins / 60);
    const travelMin = Math.round(travellingMins % 60);
    const travelDuration = travelHrs > 0
      ? `${travelHrs}h ${travelMin}m`
      : travellingMins > 0 ? `${Math.round(travellingMins)}m` : "—";

    const workDuration = getSummaryDuration() || "—";
    const reportDate = fromDate ? moment(fromDate).format("D MMM YYYY") : moment().format("D MMM YYYY");
    const generatedAt = moment().format("D MMM YYYY, hh:mm:ss A");

    const photoHtml = userPhoto
      ? `<img src="${userPhoto}" style="width:64px;height:64px;border-radius:50%;object-fit:cover;border:2px solid #e0e0e0;" />`
      : `<div style="width:64px;height:64px;border-radius:50%;background:#6b46c1;color:white;display:flex;align-items:center;justify-content:center;font-size:26px;font-weight:700;">${(userName || "U").charAt(0).toUpperCase()}</div>`;

    const tableRows = fullEvents.map((event, index) => {
      let badgeStyle = "";
      if (event.status === "Halt") {
        badgeStyle = "background:#fce4ec;color:#c2185b;border:1px solid #f48fb1;";
      } else if (event.status === "Task Visited") {
        badgeStyle = "background:#e0f7f4;color:#00796b;border:1px solid #80cbc4;";
      } else {
        badgeStyle = "background:#e3f2fd;color:#1565c0;border:1px solid #90caf9;";
      }
      return `<tr>
        <td style="padding:10px 14px;border-bottom:1px solid #f0f0f0;font-size:13px;color:#333;">${index + 1}</td>
        <td style="padding:10px 14px;border-bottom:1px solid #f0f0f0;font-size:13px;color:#333;">${moment(event.startTime).format("hh:mm:ss A")}</td>
        <td style="padding:10px 14px;border-bottom:1px solid #f0f0f0;font-size:13px;color:#333;">${moment(event.endTime).format("hh:mm:ss A")}</td>
        <td style="padding:10px 14px;border-bottom:1px solid #f0f0f0;">
          <span style="padding:3px 12px;border-radius:14px;font-size:12px;font-weight:500;${badgeStyle}">${event.status}</span>
        </td>
        <td style="padding:10px 14px;border-bottom:1px solid #f0f0f0;font-size:13px;color:#333;">${event.location}</td>
      </tr>`;
    }).join("");

    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8"/>
  <title>Route Report</title>
  <style>
    *{margin:0;padding:0;box-sizing:border-box;}
    body{font-family:'Segoe UI',Arial,sans-serif;background:#f5f5f5;}
    .page{max-width:720px;margin:0 auto;background:white;box-shadow:0 2px 12px rgba(0,0,0,.1);}
    @media print{body{background:white;}.page{max-width:100%;box-shadow:none;}@page{margin:10mm;}}
  </style>
</head>
<body>
<div class="page">
  <div style="background:linear-gradient(135deg,#c2185b 0%,#6a0080 100%);padding:30px 0;text-align:center;">
    <h1 style="color:white;font-size:26px;letter-spacing:3px;font-weight:600;">Route&nbsp; Report</h1>
  </div>
  <div style="margin:20px;border:1px solid #e0e0e0;border-radius:8px;padding:18px 24px;display:flex;gap:20px;align-items:center;">
    <div style="flex-shrink:0;">${photoHtml}</div>
    <div style="flex:1;display:grid;grid-template-columns:1fr 1fr;gap:14px 24px;">
      <div><div style="font-size:12px;color:#888;margin-bottom:3px;">Teamplayer Name</div><div style="font-size:14px;font-weight:600;color:#111;">${userName || "—"}</div></div>
      <div><div style="font-size:12px;color:#888;margin-bottom:3px;">Team</div><div style="font-size:14px;font-weight:600;color:#111;">${teamName || "—"}</div></div>
      <div><div style="font-size:12px;color:#888;margin-bottom:3px;">Date</div><div style="font-size:14px;font-weight:600;color:#111;">${reportDate}</div></div>
      <div><div style="font-size:12px;color:#888;margin-bottom:3px;">Report generated at date and time</div><div style="font-size:14px;font-weight:600;color:#111;">${generatedAt}</div></div>
    </div>
  </div>
  <div style="margin:0 20px 20px;">
    <table style="width:100%;border-collapse:collapse;">
      <thead>
        <tr style="background:#f5f5f5;">
          <th style="padding:10px 14px;text-align:left;font-size:13px;color:#555;border-bottom:2px solid #e0e0e0;">Sl.No</th>
          <th style="padding:10px 14px;text-align:left;font-size:13px;color:#555;border-bottom:2px solid #e0e0e0;">Start Time</th>
          <th style="padding:10px 14px;text-align:left;font-size:13px;color:#555;border-bottom:2px solid #e0e0e0;">End Time</th>
          <th style="padding:10px 14px;text-align:left;font-size:13px;color:#555;border-bottom:2px solid #e0e0e0;">Status</th>
          <th style="padding:10px 14px;text-align:left;font-size:13px;color:#555;border-bottom:2px solid #e0e0e0;">Location</th>
        </tr>
      </thead>
      <tbody>
        ${tableRows || '<tr><td colspan="5" style="padding:24px;text-align:center;color:#888;font-size:13px;">No route data available for this date</td></tr>'}
      </tbody>
    </table>
  </div>
  <div style="margin:0 20px 28px;">
    <div style="font-size:16px;font-weight:600;color:#111;margin-bottom:14px;">Route Summary</div>
    <div style="display:flex;gap:12px;">
      <div style="flex:1;border:1px solid #e0e0e0;border-radius:8px;padding:14px 16px;display:flex;align-items:center;gap:12px;">
        <span style="font-size:26px;">🕐</span>
        <div><div style="font-size:12px;color:#888;margin-bottom:4px;">Total Hrs Worked</div><div style="font-size:22px;font-weight:700;color:#111;">${workDuration}</div></div>
      </div>
      <div style="flex:1;border:1px solid #e0e0e0;border-radius:8px;padding:14px 16px;display:flex;align-items:center;gap:12px;">
        <span style="font-size:26px;">📍</span>
        <div><div style="font-size:12px;color:#888;margin-bottom:4px;">Total Hrs Travelled</div><div style="font-size:22px;font-weight:700;color:#111;">${travelDuration}</div></div>
      </div>
      <div style="flex:1;border:1px solid #e0e0e0;border-radius:8px;padding:14px 16px;display:flex;align-items:center;gap:12px;">
        <span style="font-size:26px;">🚌</span>
        <div><div style="font-size:12px;color:#888;margin-bottom:4px;">Distance Travelled in the Day (Kms)</div><div style="font-size:22px;font-weight:700;color:#111;">${totalDistance}</div></div>
      </div>
    </div>
  </div>
</div>
<script>window.onload=function(){window.print();}</script>
</body>
</html>`;

    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(html);
      printWindow.document.close();
    }
  };

  return (
    <div style={{ margin: "-20px", display: "flex", flexDirection: "column", height: "calc(100vh - 70px)" }}>
      <div className={classes.brudCrumb} style={{ padding: "10px 20px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <BsArrowLeftShort
            style={{ width: "30px", height: "30px" }}
            onClick={() => navigate(-1)}
          />
          <span onClick={() => navigate("/maps")}>Map</span>
          <NavigateNextIcon fontSize="small" />
          <span>View Route</span>
        </div>
        <Button
          variant="outlined"
          size="small"
          onClick={generateRouteReport}
          style={{ textTransform: "none", fontSize: "13px", borderRadius: "6px" }}
        >
          Download Report
        </Button>
      </div>
      <div style={{ flex: 1, position: "relative" }}>
        <FilterContainer dateObject={dateObject} selectedDate={fromDate} />
        {(totalDistance > 0 || getSummaryDuration()) && (
          <div style={{
            position: "absolute",
            top: "70px",
            left: "10px",
            zIndex: 10,
            background: "white",
            borderRadius: "10px",
            padding: "10px 16px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            display: "flex",
            gap: "20px",
            alignItems: "center",
            fontSize: "13px",
            fontFamily: "Noto Sans, sans-serif",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ fontSize: "16px" }}>📍</span>
              <div>
                <div style={{ color: "#6b778c", fontSize: "11px", lineHeight: 1.2 }}>Distance</div>
                <div style={{ color: "#0a1f41", fontWeight: 600 }}>{totalDistance} km</div>
              </div>
            </div>
            {getSummaryDuration() && (
              <>
                <div style={{ width: "1px", height: "32px", background: "#e0e0e0" }} />
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span style={{ fontSize: "16px" }}>⏱</span>
                  <div>
                    <div style={{ color: "#6b778c", fontSize: "11px", lineHeight: 1.2 }}>Duration</div>
                    <div style={{ color: "#0a1f41", fontWeight: 600 }}>{getSummaryDuration()}</div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      <GoogleMap
        center={mapcenter || { lat: 20.5937, lng: 78.9629 }}
        zoom={12}
        onClick={() => {
          setActiveMarker(null);
          setActiveLocation(null);
        }}
        mapContainerStyle={{ height: "100%", width: "100%" }}
      >
        {activePointer ? (
          <div className={classes.mapcardContainer}>
            <Card
              key={activePointer?.item?._id}
              className={classes.CardContainer}
            >
              <CardContent sx={{ padding: "0px !important" }}>
                {activePointer?.isIdle && (
                  <Typography style={{ fontWeight: 600, marginBottom: "6px", color: "#B45309" }}>
                    Idle period
                  </Typography>
                )}
                <Typography>
                  Start Time:&nbsp;
                  {moment(activePointer?.time).format("hh:mm A")}
                </Typography>
                <Typography>
                  End Time:&nbsp;
                  {moment(activePointer?.endTime).format("hh:mm A")}
                </Typography>
                <Typography>
                  Time Spent:&nbsp;{getTimeDifference(activePointer?.duration)}
                </Typography>
                <Typography
                  style={{ marginTop: "6px", fontSize: "12px", color: "#6b778c", cursor: "pointer" }}
                  onClick={() => setActivePointer(null)}
                >
                  ✕ close
                </Typography>
              </CardContent>
            </Card>
          </div>
        ) : activeLocation ? (
          <div className={classes.mapcardContainer}>
            <Card key={activeLocation.id} className={classes.CardContainer}>
              <CardContent sx={{ padding: "0px !important" }}>
                <div className={classes.locationDeatilsHeader}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "10px",
                    }}
                  >
                    <div className={classes.memberCardText}>
                      <h5 style={{ marginBottom: 0 }}>
                        {activeLocation.location.title}
                      </h5>
                    </div>
                  </div>
                  <Chip
                    label={activeLocation.status}
                    size="small"
                    style={getChipColor(activeLocation.status)}
                  />
                </div>
                <hr className={classes.UnderlineHr} />
                <div>
                  <div className={classes.memberCardText}>
                    <p>
                      {activeLocation.status === "completed"
                        ? "Reached ON"
                        : "Assigned on"}
                    </p>
                    <h5>
                      {moment(
                        activeLocation.status === "completed"
                          ? activeLocation.reached_date
                          : activeLocation?.location?.assigned_on
                      ).format("DD MMM YYYY,hh:mm A")}
                    </h5>
                  </div>
                  <hr className={classes.UnderlineHr} />
                  <div>
                    {activeLocation.status === "completed" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="outlined"
                          size="small"
                          style={{
                            textTransform: "none",
                            width: "45%",
                          }}
                          onClick={(event) =>
                            handleViewRoute(event, activeLocation)
                          }
                        >
                          view route
                        </Button>
                        <Button
                          variant="contained"
                          type="submit"
                          size="small"
                          style={{
                            textTransform: "none",
                            width: "45%",
                          }}
                          onClick={(e) => handleNotReached(e, activeLocation)}
                        >
                          Not reached?
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          variant="outlined"
                          size="small"
                          fullWidth
                          style={{
                            width: "100%",
                            textTransform: "none",
                          }}
                          onClick={(event) =>
                            handleViewRoute(event, activeLocation)
                          }
                        >
                          view route
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        ) : (
          <div>
            {markerList && markerList?.length > 0 ? (
              <div className={classes.mapcardContainer}>
                <Paper elevation={3}>
                  <Card
                    sx={{ maxWidth: 345 }}
                    className={classes.CardContainer}
                  >
                    <CardHeader
                      title="Routes"
                      className={`${classes.CardHeaderContainer} ${classes.piechartHeading} `}
                    />
                    <hr className={classes.UnderlineHr} />
                    <CardContent
                      className={`${classes.CardContentContainer} ${classes.CardContent1} `}
                    >
                      <Typography className={classes.cardLabelText}>
                        Total Distance Travelled
                      </Typography>
                      <Typography
                        className={classes.cardImpText}
                      >{`${totalDistance} km`}</Typography>
                    </CardContent>
                    <hr className={classes.UnderlineHr} />
                    <CardActions
                      disableSpacing
                      className={classes.CardActionContainer}
                    >
                      <Typography
                        className={`${classes.cardImpText} ${classes.CollapseHeader} `}
                      >
                        View Details
                      </Typography>
                      <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                      >
                        <ExpandMoreIcon />
                      </ExpandMore>
                    </CardActions>
                    <Collapse
                      in={expanded}
                      timeout="auto"
                      unmountOnExit
                      className={classes.CardCollapeContainer}
                    >
                      <div style={{ marginTop: "20px" }}>
                        {markerList
                          .filter((item) => item.status === "completed")
                          .map((item, index) => {
                            return (
                              <div key={index}>
                                <CardContent
                                  key={index}
                                  className={`${classes.CardContentContainer} ${classes.Card} `}
                                >
                                  <Typography className={classes.cardImpText}>
                                    {item.location.title}
                                  </Typography>
                                  <Typography className={classes.cardLabelText}>
                                    {moment(item?.location?.assigned_on).format(
                                      "DD/MM/YYYY | hh:mm a"
                                    )}
                                  </Typography>
                                </CardContent>
                                {index !== markerList.length - 1 ? (
                                  <hr className={classes.UnderlineHr} />
                                ) : null}
                              </div>
                            );
                          })}
                      </div>
                    </Collapse>
                  </Card>
                </Paper>
              </div>
            ) : null}
          </div>
        )}
        {markerList &&
          markerList?.length > 0 &&
          markerList.map((item, index) => {
            console.log("BeforeMarker", item);
            return (
              <Marker
                key={index}
                onClick={() => handleActiveMarker(item)}
                position={{
                  lat: parseFloat(item?.location?.location_info?.lat),
                  lng: parseFloat(item?.location?.location_info?.lng),
                }}
                icon={{
                  url: `data:image/svg+xml;utf-8,${encodeURIComponent(
                    getMarkerSVG(item)
                  )}`,
                  anchor: new window.google.maps.Point(24, 24),
                  scaledSize: new window.google.maps.Size(32, 32),
                }}
                // icon={{
                //   url: `data: image / svg + xml; utf - 8, ${encodeURIComponent(
                //     getMarkerSVG(item)
                //   )} `,
                //   anchor: new window.google.maps.Point(24, 24),
                //   scaledSize: new window.google.maps.Size(32, 32),
                // }}
              />
            );
          })}
        {travelHistory &&
          travelHistory?.length > 0 &&
          travelHistory[0]?.[0]?.location_info && (
            <Marker
              position={{
                lat: parseFloat(travelHistory[0][0].location_info.lat),
                lng: parseFloat(travelHistory[0][0].location_info.lng),
              }}
              title="Start Point"
              icon={{
                url: `data:image/svg+xml;utf-8,${encodeURIComponent(
                  getOtherIcons("start")
                )}`,
                anchor: new window.google.maps.Point(18, 44),
                scaledSize: new window.google.maps.Size(36, 44),
              }}
            />
          )}
        {travelHistory &&
          travelHistory?.length > 0 &&
          travelHistory[travelHistory.length - 1]?.[
            travelHistory[travelHistory.length - 1]?.length - 1
          ]?.location_info && (
            <Marker
              position={{
                lat: parseFloat(travelHistory[travelHistory.length - 1][travelHistory[travelHistory.length - 1].length - 1].location_info.lat),
                lng: parseFloat(travelHistory[travelHistory.length - 1][travelHistory[travelHistory.length - 1].length - 1].location_info.lng),
              }}
              title="End Point"
              icon={{
                url: `data:image/svg+xml;utf-8,${encodeURIComponent(
                  getOtherIcons("end")
                )}`,
                anchor: new window.google.maps.Point(18, 44),
                scaledSize: new window.google.maps.Size(36, 44),
              }}
            />
          )}
        {/* {endLocation && (
          <Marker
            position={endLocation}
            icon={{
              url: `data: image / svg + xml; utf - 8, ${
  encodeURIComponent(
    getOtherIcons("end")
  )
} `,
              anchor: new window.google.maps.Point(24, 24),
              scaledSize: new window.google.maps.Size(32, 32),
            }}
          />
        )} */}
        {/* {directions && (
          <DirectionsRenderer
            directions={directions}
            options={{
              suppressMarkers: true, // Prevents default markers from showing
              polylineOptions: {
                strokeColor: "#1C71B3", // Customize the polyline color
                strokeOpacity: 1,
                strokeWeight: 3,
              },
            }}
          />
        )} */}

        {!isReplaying &&
          polylinePath?.length > 0 &&
          travelHistory?.length > 0 &&
          polylinePath.map((item, index) => (
            <React.Fragment key={index}>
              <Polyline
                path={item}
                options={{
                  strokeColor: "#1C71B3",
                  strokeOpacity: 1,
                  strokeWeight: 3,
                }}
                mouseover={() => handleMouseOver(index)}
                // onMouseOut={handleMouseOut}
              />
            </React.Fragment>
          ))}
        {isReplaying && replayRemaining.length > 1 && (
          <Polyline
            path={replayRemaining}
            options={{
              strokeColor: "#93C5FD",
              strokeOpacity: 0.9,
              strokeWeight: 3,
            }}
          />
        )}
        {isReplaying && replayTraveled.length > 1 && (
          <Polyline
            path={replayTraveled}
            options={{
              strokeColor: "#2563EB",
              strokeOpacity: 1,
              strokeWeight: 5,
            }}
          />
        )}
        {isReplaying && playback.currentPosition && (
          <Marker
            position={playback.currentPosition}
            zIndex={999}
            icon={{
              url: `data:image/svg+xml;utf-8,${encodeURIComponent(
                getReplayMarkerSVG()
              )}`,
              anchor: new window.google.maps.Point(17, 17),
              scaledSize: new window.google.maps.Size(34, 34),
            }}
          />
        )}
        {stopPoints &&
          stopPoints?.length > 0 &&
          stopPoints.map((item, index) => {
            return (
              <Marker
                key={index}
                position={{
                  lat: parseFloat(item?.item?.location_info?.lat),
                  lng: parseFloat(item?.item?.location_info?.lng),
                }}
                onClick={() => setActivePointer(item)}
              ></Marker>
            );
          })}
        {idlePoints?.length > 0 &&
          idlePoints.map((item, index) => (
            <Marker
              key={`idle-${index}`}
              position={{
                lat: parseFloat(item.item.location_info.lat),
                lng: parseFloat(item.item.location_info.lng),
              }}
              icon={{
                url: `data:image/svg+xml;utf-8,${encodeURIComponent(
                  getIdleMarkerSVG(item.duration)
                )}`,
                anchor: new window.google.maps.Point(35, 33),
              }}
              onClick={() => setActivePointer(item)}
            />
          ))}
      </GoogleMap>
      <RouteReplayControls
        visible={playback.canPlay}
        isPlaying={playback.isPlaying}
        canPlay={playback.canPlay}
        progress={playback.progress}
        speed={playback.speed}
        virtualTime={playback.virtualTime}
        endTs={playback.endTs}
        activeHaltDuration={activeHaltDuration}
        onToggle={playback.toggle}
        onSeek={playback.seekTo}
        onSpeedChange={playback.setSpeed}
        onScrubStart={handleScrubStart}
        onScrubEnd={handleScrubEnd}
      />
      </div>
    </div>
  );
}

const GOOGLE_MAPS_LIBRARIES = ["geometry"];

export default function ViewRoute() {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  return isLoaded ? <Map /> : <div>Loading Google Maps...</div>;
}
